import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tacvsj4rz9: FaireBrandEntity = {
  token: "b_tacvsj4rz9",
  type: "brand",
  name: "9 Priscilla Way",
  avatarUrl:
    "https://cdn.faire.com/fastly/502c0ba920389708f4dacd525a9652be322e2a100827153d96ae81ff1b55eb4c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6f3f97f102fbe616147d8641286f9edc04e2c5ab1fe1e0e331b5f9717d2e78a6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/502c0ba920389708f4dacd525a9652be322e2a100827153d96ae81ff1b55eb4c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6f3f97f102fbe616147d8641286f9edc04e2c5ab1fe1e0e331b5f9717d2e78a6.jpeg",
  location: "Cranston, RI, USA",
  minimumOrderDollars: 208,
  rating: 4.7,
  reviewCount: 12,
  isInsider: true,
  description:
    "Let's just dive right into my story and get a little personal! I am a mama of two girls, my oldest being 2 1/2 and youngest just recently turned 1. I started \"crafting\" and creating in early 2020 shortly after giving birth to my second little girl and the start of the dreaded P word. After the birth of my second daughter I was diagnosed with postpartum depression and truly felt so lost in who I was as a person. Creating signs and small gifts gave me a wonderful outlet and place to really express myself and get out of my own head. Shortly after creating some Mother's Day gifts for my mother in law and grandmother, I had tons of requests for custom signs and from there 9 Priscilla Way was born! \n\nStarting this wonderful small business has been amazing, being able to create and share my ideas is a blessing. I am always looking to add new products and designs to my shop and look forward to the future! \n\n-With love,\nVictoria",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:56.215Z",
    importedBy: "entity-db-cli",
  },
};
